import AgencyRegistrationApplicationService from '../services/AgencyRegistrationApplications';
import PrintUtility from '../utilities/printUtility';
import { FILE_CODE } from '../utilities/constants';

export const useAgencyRegistrationApplicationDownLoader = () => {
  const wordTemplateDownLoad = async () => {
    const response = await AgencyRegistrationApplicationService.downloadTemplate(
      1
    );
    const blob = new Blob([response], {
      type:
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
    PrintUtility.printBlob(
      blob,
      '覚書テンプレートファイル.docx',
      FILE_CODE.WORD
    );
  };

  const pdfTemplateDownLoad = async () => {
    await PrintUtility.printOrOpenBlob(
      async () => {
        const response = await AgencyRegistrationApplicationService.downloadTemplate(
          2
        );
        return new Blob([response], { type: 'application/pdf' });
      },
      '覚書テンプレートファイル.pdf',
      FILE_CODE.PDF,
      false
    );
  };

  const updateContentDownLoad = async () => {
    await PrintUtility.printOrOpenBlob(
      async () => {
        const response = await AgencyRegistrationApplicationService.downloadTemplate(
          3
        );
        return new Blob([response], { type: 'application/pdf' });
      },
      '下位協力会社の代行登録設定方法の変更内容.pdf',
      FILE_CODE.PDF,
      false
    );
  };

  return {
    wordTemplateDownLoad,
    pdfTemplateDownLoad,
    updateContentDownLoad,
  };
};

export default useAgencyRegistrationApplicationDownLoader;



// WEBPACK FOOTER //
// ./src/components/useAgencyRegistrationApplicationDownLoader.js